import React from 'react';
import { StarIcon } from 'lucide-react';
interface StarsProps {
  count?: number;
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}
const sizes = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-7 w-7'
};
export function Stars({
  count = 5,
  size = 'sm',
  label = '5 de 5 estrellas'
}: StarsProps) {
  const gap = size === 'lg' ? 'gap-1.5' : 'gap-1';
  return <div className={`flex items-center ${gap}`} role="img" aria-label={label} data-id="element-314" data-mp="3pn53z9zeagpu">
      {Array.from({
      length: count
    }).map((_, i) => <span key={i} className="flex items-center justify-center bg-trust p-[2px]" aria-hidden="true" data-id="element-315" data-mp="3hhx28dwucwy" data-mpi={i}>
          <StarIcon className={`${sizes[size]} fill-white text-white`} data-id="element-316" data-mp="8884rs9t6rut" />
        </span>)}
    </div>;
}